export enum CellRenderer {
  default = 'default',
  input = 'input'
}
